import { SHARED } from "src/app/shared/shared";
import { Component } from "@angular/core";

@Component({
  selector: "dentr-login-terms-gb",
  templateUrl: "./login-terms-gb.component.html",
  standalone: true,
  imports: [SHARED],
})
export class LoginTermsGBComponent {}
